<form [formGroup]="form" (ngSubmit)="onSave()" class="formgrid grid">

  <div class="col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Name</h3>
    <input pInputText formControlName="name" type="text" class="inputfield w-full"
      (input)="onNameInput()"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('name')?.invalid && form.get('name')?.touched }"
      placeholder="Gotcha4Life" />
  </div>

  <div class="col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Slug</h3>
    <input pInputText formControlName="slug" type="text" class="inputfield w-full"
      [readonly]="slugIsReadOnly"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('slug')?.invalid && form.get('slug')?.touched, 'surface-100': slugIsReadOnly }"
      placeholder="gotcha4life" />
    <small class="block text-500 mt-1">
      Auto-generated from the name (lowercase, spaces → "-").
      <a class="cursor-pointer text-primary font-medium" (click)="toggleSlugEdit()">{{ slugIsReadOnly ? 'Edit manually' : 'Auto from name' }}</a>
    </small>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Website</h3>
    <input pInputText formControlName="url" type="url" class="inputfield w-full" placeholder="https://gotcha4life.org" />
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Short description</h3>
    <textarea pInputTextarea formControlName="intro" rows="2" class="inputfield w-full"
      placeholder="Picaluna is pleased to support their tireless work in animal rescue and rehoming."></textarea>
    <small class="block text-500 mt-1">
      One line about Picaluna's relationship with them. Shows on the charity partners
      listing and at the top of their page. Plain text — no formatting.
    </small>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Full description <span class="text-500 text-sm font-normal">(Markdown)</span></h3>
    <app-markdown-editor
      formControlName="description"
      [heightRem]="18"
      imageBucketPrefix="charity-body"
      [imageAltFallback]="form.get('name')?.value || 'Charity image'"
      placeholder="What the charity does, in their own right."
    ></app-markdown-editor>
    <small class="block mt-1 text-500">
      Use the Preview button to see this as it will appear on picaluna.com.
    </small>
  </div>

  <!-- ABOVE the logo: this is the big photo across the top of the charity's page,
       and without one every charity shares the same stock ceremony image. -->
  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Hero image</h3>
    <div class="flex align-items-center gap-3">
      <img *ngIf="heroPreview" [src]="heroPreview" alt="Hero preview" style="height: 48px; width: auto; border-radius: 6px;" />
      <span *ngIf="!heroPreview && heroFileId" class="text-500 text-sm">Hero attached</span>
      <button pButton pRipple type="button" [label]="heroFileId ? 'Replace hero' : 'Upload hero'" icon="pi pi-upload" class="p-button-outlined" (click)="uploadHero()"></button>
      <button *ngIf="heroFileId" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger" (click)="removeHero()"></button>
      <small class="text-500">The wide photo at the top of their page.</small>
    </div>
  </div>

  <div class="col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Logo</h3>
    <div class="flex align-items-center gap-3">
      <img *ngIf="logoPreview" [src]="logoPreview" alt="Logo preview" style="height: 48px; width: auto; border-radius: 6px;" />
      <span *ngIf="!logoPreview && logoFileId" class="text-500 text-sm">Logo attached</span>
      <button pButton pRipple type="button" [label]="logoFileId ? 'Replace logo' : 'Upload logo'" icon="pi pi-upload" class="p-button-outlined" (click)="uploadLogo()"></button>
      <button *ngIf="logoFileId" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger" (click)="removeLogo()"></button>
    </div>
  </div>

  <div class="col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Order</h3>
    <input pInputText formControlName="order" type="number" class="inputfield w-full" />
  </div>

  <div class="col-12 flex align-items-center mt-3">
    <p-inputSwitch class="flex-initial" formControlName="published"></p-inputSwitch>
    <span class="ml-2 text-700">Published (shown on picaluna.com)</span>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-3">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
    <button pButton pRipple type="submit" label="Save" icon="pi pi-check" [loading]="saving"></button>
  </div>

</form>
